import { BH_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { isClientSide } from "@helper/utils";
import { TaboolaPageType } from "@typings/Ads";
import { useEffect } from "react";

export interface TaboolaProps {
  mode: string;
  container: string;
  placement: string;
  targetType?: string;
  pathName?: string;
  isFlush?: boolean;
  pageType: TaboolaPageType;
  counter?: number;
}
export default function Taboola({
  mode,
  container,
  placement,
  targetType = "mix",
  pathName,
  isFlush,
  pageType,
  counter,
}: TaboolaProps) {
  const pageUrl =
    pathName !== undefined
      ? `${removeTrailingSlash(BH_BASE_URL)}${pathName}`
      : removeTrailingSlash(BH_BASE_URL);
  const containerId =
    counter !== undefined ? `${container}-${counter}` : container;
  const placementName =
    counter !== undefined ? `${placement}-${counter}` : placement;

  useEffect(() => {
    if (!isClientSide) return;

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    window._taboola = window._taboola || [];

    // Context push
    const contextPayload =
      pageType === "homepage"
        ? { homepage: "auto" }
        : {
            [pageType]: "auto",
            url: pageUrl,
          };

    window._taboola.push(contextPayload);

    //widget push
    window._taboola.push({
      mode,
      container: containerId,
      placement: placementName,
      target_type: targetType,
    });
    if (isFlush) {
      window._taboola.push({ flush: true });
    }
  }, [
    pageType,
    pageUrl,
    mode,
    containerId,
    placementName,
    targetType,
    isFlush,
  ]);

  return <div id={containerId} className="min-h-[150px]"></div>;
}
